import React from "react";
import { SwiperSlide } from "swiper/react";
import { Swiper as _Swiper } from "swiper/react";

const Swiper = ({ children, ...other }) => {
	return <_Swiper {...other}>{children}</_Swiper>;
};

export { SwiperSlide, Swiper };